import { terminalText } from "./terminal.js";
import { h } from "./ui/dom.js";
import { icon } from "./ui/icons.js";

export function activityLabel(run) {
  const settled = {
    starting: "Starting",
    waiting_approval: "Waiting for approval",
    completed: "Ready for review",
    applied: "Changes applied",
    discarded: "Changes discarded",
    cancelled: "Stopped",
    error: "Could not finish",
    unknown: "Status unavailable",
  };
  if (settled[run.status]) return settled[run.status];
  const item = run.items?.at(-1) || run.latest;
  if (["completed", "failed", "cancelled"].includes(item?.status))
    return "Working";
  if (item?.command)
    return /(?:\btest\b|\bpytest\b|\bvitest\b|\bjest\b)/i.test(item.command)
      ? "Running tests"
      : "Running a command";
  if (item?.type === "reasoning") return "Thinking";
  if (item?.type === "fileChange") return "Editing files";
  return "Working";
}

export function usageText(usage) {
  if (!usage) return "Token usage not reported";
  const parts = [
    [usage.inputTokens, "input"],
    [usage.outputTokens, "output"],
    [usage.reasoningTokens, "reasoning"],
    [usage.totalTokens, "total"],
  ].filter(([count]) => Number.isSafeInteger(count) && count >= 0);
  return parts.length
    ? `${parts.map(([count, label]) => `${count.toLocaleString()} ${label}`).join(" · ")} tokens (provider-reported)`
    : "Token usage not reported";
}

/** Shared by the conversation and Changes: receipt details stay collapsed. */
export function runActivity(run) {
  const items = run.items.filter((item) => item.type !== "agentMessage");
  const activity = h(
    "details",
    {
      class: "ui-run-activity",
      dataset: { key: `activity-${run.id}`, detailKey: `activity-${run.id}` },
    },
    h(
      "summary",
      {},
      icon("activity"),
      h("span", { text: `Activity · ${items.length} steps` }),
      h("span", { class: "ui-run-activity__state", text: activityLabel(run) }),
    ),
  );
  activity.append(h("p", { class: "muted", text: usageText(run.usage) }));
  for (const item of items) {
    const title =
      item.command ||
      (item.type === "reasoning"
        ? "Thinking summary"
        : item.type === "fileChange"
          ? "File changes"
          : "Agent activity");
    const details = h(
      "details",
      {
        class: "ui-run-activity__item",
        dataset: { key: `item-${item.id}`, detailKey: `item-${item.id}` },
      },
      h(
        "summary",
        {},
        icon(
          item.command
            ? "terminal"
            : item.type === "fileChange"
              ? "file"
              : "activity",
        ),
        h("span", {
          class: "ui-run-activity__label",
          text: terminalText(title),
        }),
        h("span", {
          class: "ui-run-activity__state",
          text: item.exitCode != null ? `exit ${item.exitCode}` : item.status,
        }),
      ),
    );
    if (item.text) details.append(h("p", { text: terminalText(item.text) }));
    if (item.command || item.output)
      details.append(
        h("pre", {
          tabIndex: 0,
          text: terminalText(item.output || "No output recorded."),
        }),
      );
    if (item.type === "reasoning" && !item.text)
      details.append(
        h("p", {
          class: "muted",
          text: "The provider did not report a thinking summary.",
        }),
      );
    activity.append(details);
  }
  return activity;
}
